import { AnyAction } from 'redux';

import { driversActions } from '../reducer';

export const resetSelectedDriverLocation = (): AnyAction => driversActions.setSelectedDriverLocation(undefined);
